<div class="login-container">
  <ng-container *transloco="let t;">
  <h2>{{t('auth.login_form.title')}}</h2>

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" aria-label="Login Form">
    <mat-form-field appearance="outline">
      <mat-label>{{t('auth.login_form.email_label')}}</mat-label>
      <input matInput type="email" formControlName="email" placeholder="Enter your email">
      @if (loginForm.get('email')?.hasError('required')) {
        <mat-error>{{t('auth.login_form.email_err_required')}}</mat-error>
      }
      @if (loginForm.get('email')?.hasError('email')) {
        <mat-error>{{t('auth.login_form.email_err_invalid')}}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{t('auth.login_form.password_label')}}</mat-label>
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
      <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" aria-label="Toggle Password Visibility">
        <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      @if (loginForm.get('password')?.hasError('required')) {
        <mat-error>{{t('auth.login_form.password_err_required')}}</mat-error>
      }
    </mat-form-field>

    <div class="actions">
      <button mat-raised-button color="secondary" routerLink="/auth/register">{{t('auth.login_form.create_account_button')}}</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid || isLoading()">{{ isLoading() ? t('auth.login_form.signing_in_button') : t('auth.login_form.sign_in_button') }}</button>
    </div>
  </form>

  <mat-divider class="divider">OR</mat-divider>

  <button mat-stroked-button (click)="signInWithGoogle()" [disabled]="isLoading()">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48">
      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12	s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20	s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039	l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36	c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571	c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
    </svg>
    {{t('auth.login_form.google_button')}}
  </button>
  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
  </ng-container>
</div>
